import React, { useState, useEffect, useRef } from "react";
import { BannerLogo } from "../../components/BannerLogo";
import iconG from "../../assets/Login/Icon-Google.svg";
import { CustomInput } from "../../components/CustomInput";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import { Miniloader } from "../../components/Miniloader";

function Register() {
  const { signUp } = useAuth();
  const navigate = useNavigate();
  const checkbox = useRef(null);
  const [termsAccepted, setTermsAccepted] = useState(false); // Estado para controlar si se aceptaron los términos y condiciones
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onSubmit",
    resolver: (values) => {
      const errors = {};
      if (values.password !== values.confirm_password) {
        errors.confirm_password = {
          type: "manual",
          message: "Las contraseñas no coinciden",
        };
      }
      return {
        values,
        errors,
      };
    },
  });

  const [passwordValidation, setPasswordValidation] = useState({
    length: false,
    lowercaseUppercase: false,
    number: false,
    specialChar: false,
  });

  const [isFormSubmitted, setIsFormSubmitted] = useState(false); // Estado para controlar si el formulario se ha enviado

  const password = watch("password") || "";
  const confirmPassword = watch("confirm_password") || "";
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPasswordValidation({
      length: password.length >= 8,
      lowercaseUppercase: /(?=.*[a-z])(?=.*[A-Z])/.test(password),
      number: /(?=.*\d)/.test(password),
      specialChar: /(?=.*[@$!#()_%*?&])/.test(password),
    });
  }, [password]);

  const handleClickCheckbox = () => {
    if (checkbox.current?.checked) {
      checkbox.current.checked = false;
    } else {
      checkbox.current.checked = true;
    }
  };

  const onSubmit = async (data) => {
    if(passwordValidation.length === false || passwordValidation.lowercaseUppercase === false || passwordValidation.number === false || passwordValidation.specialChar === false) return;
    if(data.password !== data.confirm_password) return;
    setLoading(true);

    try {
      await signUp(data); // Registra al usuario
      setLoading(false);
      setIsFormSubmitted(true); // Cambiar el estado al enviar el formulario exitosamente
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handleLoginClick = () => {
    navigate("/login");
  };

  if (isFormSubmitted) {
    return (
      <div className="grid grid-cols-2 w-screen h-svh bg-[#EAEAEA]">
        <BannerLogo />
        <div className="flex w-full h-svh justify-center items-center">
          <div className="flex flex-col fixed top-0 right-0 h-svh w-[50svw] px-[10%] py-[6%] justify-center items-center gap-[2rem]">
            <div className="flex w-full justify-start gap-4">
              <img src="/assets/Login/icon-good.svg" alt="good_Icon" />
              <h1 className="text-2xl text-nemu-green ">Solicitud enviada exitosamente</h1>
            </div>
            <p className="text-base">Tu solicitud de registro a Nemu ha sido enviada exitosamente. Revisa tu correo electrónico, te enviaremos un correo cuando tu solicitud haya sido aceptada por el equipo de administración de Nemu.
            ¡Muchas gracias!</p>
            <button className="flex w-full justify-center items-center px-[1.5rem] py-3 bg-[#282827] rounded-[8px]">
                <span onClick={handleLoginClick} className="text-white">Regresar al website de Nemu</span>
              </button>
          </div>   
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 w-screen h-svh bg-[#EAEAEA]">
      <BannerLogo />
      <div className="flex w-full h-svh justify-center items-center">
        <div className="flex flex-col fixed top-0 right-0 h-svh w-[50svw] px-[10%] py-[6%] justify-start items-center gap-[2rem] overflow-y-scroll">
          <div className="flex flex-col w-full text-start gap-[0.125rem] ">
            <h1 className="text-[2rem]" onClick={() => console.log(!checkbox.current?.checked)}>Crea una cuenta</h1>
            <p className="text-[1.25rem]">
              Regístrate y accede a nuestra plataforma.
            </p>
          </div>
          <div className="flex flex-col w-full gap-[1.125rem] items-center">
            {Object.keys(errors).length > 0 && (
              <div className="w-full px-4 py-2 bg-red-100 border border-red-400 text-red-700 rounded">
                <ul>
                  {errors.development_name && (
                    <li>Nombre de la desarrolladora es requerido</li>
                  )}
                  {errors.username && <li>Nombre completo es requerido</li>}
                  {errors.email && <li>Correo electrónico es requerido</li>}
                  {errors.phone && <li>Teléfono es requerido</li>}
                  {errors.password && <li>{errors.password.message}</li>}
                  {errors.confirm_password && (
                    <li>{errors.confirm_password.message}</li>
                  )}
                </ul>
              </div>
            )}
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col w-full gap-[0.75rem]"
            >
              <CustomInput
                bg="bg-transparent"
                type="text"
                id="username"
                name="username"
                border="border-black"
                placeholder="Nombre de la desarrolladora"
                {...register("development_name", { required: true })}
              />
              <CustomInput
                bg="bg-transparent"
                type="text"
                id="fullname"
                name="fullname"
                border="border-black"
                placeholder="Nombre completo"
                {...register("username", { required: true })}
              />
              <CustomInput
                bg="bg-transparent"
                type="email"
                id="email"
                name="email"
                border="border-black"
                placeholder="Correo electrónico"
                {...register("email", { required: true })}
              />
              <CustomInput
                bg="bg-transparent"
                type="tel"
                id="phone"
                name="phone"
                border="border-black"
                placeholder="Teléfono"
                {...register("phone", { required: true })}
              />
              <CustomInput
                bg="bg-transparent"
                type="password"
                id="password"
                name="password"
                border="border-black"
                placeholder="Contraseña"
                {...register("password", {
                  required: "La contraseña es obligatoria",
                  validate: {
                    length: (value) =>
                      value.length >= 8 || "Debe tener al menos 8 caracteres",
                    lowercaseUppercase: (value) =>
                      /(?=.*[a-z])(?=.*[A-Z])/.test(value) ||
                      "Debe tener una letra minúscula y una mayúscula",
                    number: (value) =>
                      /(?=.*\d)/.test(value) || "Debe tener al menos un número",
                    specialChar: (value) =>
                      /(?=.*[@$!%*?&])/.test(value) ||
                      "Debe tener al menos un carácter especial",
                  },
                })}
              />
              <CustomInput
                bg="bg-transparent"
                type="password"
                id="confirm_password"
                name="confirm_password"
                border="border-black"
                placeholder="Confirmar contraseña"
                {...register("confirm_password", { required: true })}
              />
              <div className="flex flex-col gap-[4px]">
                <ul className="list-disc pl-5">
                  <li
                    className={`${
                      passwordValidation.length
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    Al menos 8 caracteres
                  </li>
                  <li
                    className={`${
                      passwordValidation.lowercaseUppercase
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    Al menos una letra minúscula y una mayúscula
                  </li>
                  <li
                    className={`${
                      passwordValidation.number
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    Al menos un número
                  </li>
                  <li
                    className={`${
                      passwordValidation.specialChar
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    Al menos un carácter especial @ $ ! # ( ) _ % * ? &
                  </li>
                  <li
                    className={`${
                      password === confirmPassword
                        ? "text-green-600"
                        : "text-red-600"
                    }`}
                  >
                    Las contraseñas deben coincidir
                  </li>
                </ul>
              </div>
              <div className="flex items-center justify-between">
                <label className="flex items-center" onClick={() => setTermsAccepted((prev) => !prev)}>
                  <div className={`w-4 h-4 rounded-[4px]  ${termsAccepted ? 'bg-nemu-azul' : 'border border-nemu-black'} cursor-pointer`}></div>
                  <span className="ml-2 mt-[0.063rem] text-[1rem]">
                    Acepto los{' '}
                    <a
                      href="https://nemu.mx/terms-and-conditions"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => e.stopPropagation()}
                      className="underline hover:text-nemu-azul"
                    >
                      Términos y Condiciones
                    </a>
                    .
                  </span>
                </label>
              </div>
              <button disabled={
                  loading || !passwordValidation.length || !passwordValidation.lowercaseUppercase || !passwordValidation.number || !passwordValidation.specialChar || password !== confirmPassword || !termsAccepted
                } className="flex w-full h-12 justify-center items-center px-[1.5rem] py-3 bg-[#282827] disabled:bg-nemu-black/60 rounded-[8px]">
              {loading ?
                <Miniloader/>
                :
                <span className="text-white">Registrar mi cuenta</span>
              }
            </button>
            </form>
            <div className="flex gap-[10px]">
              <span className="text-[14px]">¿Ya tienes una cuenta?</span>
              <span 
                onClick={handleLoginClick} className="cursor-pointer text-[14px] text-[#4C63ED] font-medium underline">
                Inicia sesión aquí
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { Register };